import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import Offer from "../offer/Offer";
import Country from "../country/Country";
import User from "../user/User";
import Image from "../image/Image";
import StoreCustomData from "./StoreCustomData";
import JsonMappedModel from "../helpers/JsonMappedModel";
import StoreTrackingData from "./StoreTrackingData";
import Product from "../product/Product";
import Addons from "../Addons/Addons";
import CheckoutData from "../salePage/CustomData/CheckoutData";
import StoreLayout from "../store/storeLayout/StoreLayout";
import StripeCollection from "../Stripe/StripeCollection";
import Domain from "@/assets/js/models/domain/Domain";
import StorePageCollection from "@/assets/js/models/store/storePage/StorePageCollection";
import StorePage from "@/assets/js/models/store/storePage/StorePage";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Store extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Store.id_attribute_name]: null,
      [Store.product_id_attribute_name]: null,
      [Store.domain_id_attribute_name]: null,
      [Store.product_attribute_name]: Product,
      [Store.domain_type_attribute_name]: null,
      [Store.tracking_data_attribute_name]: StoreTrackingData,
      [Store.offer_id_attribute_name]: null,
      [Store.domain_offer_attribute_name]: Offer,
      [Store.domain_type_country_id_attribute_name]: null,
      [Store.domain_type_country_attribute_name]: Country,
      [Store.name_attribute_name]: null,
      [Store.domain_user_attribute_name]: User,
      [Store.domain_belong_type_attribute_name]: null,
      [Store.domain_is_default_attribute_name]: null,
      [Store.title_attribute_name]: null,
      [Store.domain_contact_email_attribute_name]: null,
      [Store.domain_logo_attribute_name]: null,
      [Store.domain_favicon_attribute_name]: Image,
      [Store.favicon_attribute_name]: Image,
      [Store.domain_dns_attribute_name]: null,
      [Store.domain_ssl_attribute_name]: null,
      [Store.primary_color_attribute_name]: null,
      [Store.secondary_color_attribute_name]: null,
      [Store.domain_logo_gallery_attribute_name]: Image,
      [Store.logo_attribute_name]: Image,
      [Store.domain_favicon_gallery_attribute_name]: Image,
      [Store.domain_verification_string_attribute_name]: null,
      [Store.phone_number_attribute_name]: null,
      [Store.company_location_attribute_name]: null,
      [Store.custom_data_attribute_name]: StoreCustomData,
      [Store.user_default_attribute_name]: 0,
      [Store.store_layout_attribute_name]: StoreLayout,
      [Store.addons_attribute_name]: Addons,
      [Store.language_type_attribute_name]: Store.ONE_LANGUAGE_TYPE,
      [Store.language_attribute_name]: Store.EN_LANGUAGE,
      [Store.checkout_data_attribute_name]: CheckoutData,
      [Store.layout_id_attribute_name]: null,
      [Store.stripes_attribute_name]: StripeCollection,
      [Store.domain_attribute_name]: Domain,
      [Store.substitution_domain_attribute_name]: Domain,
      [Store.active_attribute_name]: false,
      [Store.store_pages_attribute_name]: StorePageCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  static getContactEmailAttributeName() {
    return this.domain_contact_email_attribute_name;
  }
  static getTitleAttributeName() {
    return this.title_attribute_name;
  }
  static getDomainUserAttributeName() {
    return this.domain_user_attribute_name;
  }
  static getTypeAttributeName() {
    return this.domain_type_attribute_name;
  }
  static getOfferIdAttributeName() {
    return this.offer_id_attribute_name;
  }
  static getProductIdAttributeName() {
    return this.product_id_attribute_name;
  }
  static getTypeCountryIdAttributeName() {
    return this.domain_type_country_id_attribute_name;
  }
  static getPhoneNumberAttributeName() {
    return this.phone_number_attribute_name;
  }
  static getCompanyLocationAttributeName() {
    return this.company_location_attribute_name;
  }
  static getDomainLogoGalleryAttributeName() {
    return this.domain_logo_gallery_attribute_name;
  }
  static getDomainFaviconGalleryAttributeName() {
    return this.domain_favicon_gallery_attribute_name;
  }
  static getPrimaryColorAttributeName() {
    return this.primary_color_attribute_name;
  }
  static getSecondaryColorAttributeName() {
    return this.secondary_color_attribute_name;
  }
  static getTrackingDataAttributeName() {
    return this.tracking_data_attribute_name;
  }
  static getUserDefaultAttributeName() {
    return this.user_default_attribute_name;
  }
  static getStoreLayoutAttributeName() {
    return this.store_layout_attribute_name;
  }
  static getAddonsAttributeName() {
    return this.addons_attribute_name;
  }
  static getLogoAttributeName() {
    return this.logo_attribute_name;
  }
  static getFaviconAttributeName() {
    return this.favicon_attribute_name;
  }
  static getLanguageTypeAttributeName() {
    return this.language_type_attribute_name;
  }
  static getLanguageAttributeName() {
    return this.language_attribute_name;
  }
  static getCheckoutDataAttributeName() {
    return this.checkout_data_attribute_name;
  }
  static getLayoutIdAttributeName() {
    return this.layout_id_attribute_name;
  }
  static getStripesAttributeName() {
    return this.stripes_attribute_name;
  }
  static getDomainAttributeName() {
    return this.domain_attribute_name;
  }
  static getSubstitutionDomainAttributeName() {
    return this.substitution_domain_attribute_name;
  }
  static getActiveAttributeName() {
    return this.active_attribute_name;
  }
  static getStorePagesAttributeName() {
    return this.store_pages_attribute_name;
  }
  getOverallDomain() {
    const domain = this.getDomain();
    const substitutionDomain = this.getSubstitutionDomain();
    return domain instanceof Domain ? domain : substitutionDomain;
  }
  isActive() {
    return this.getAttribute(Store.getActiveAttributeName());
  }
  getDomain() {
    return this.getAttribute(Store.getDomainAttributeName());
  }
  getSubstitutionDomain() {
    return this.getAttribute(Store.getSubstitutionDomainAttributeName());
  }
  isUserDefault() {
    return this.getAttribute(Store.getUserDefaultAttributeName());
  }
  getLogo() {
    var _ref, _this$getAttribute;
    return (_ref = (_this$getAttribute = this.getAttribute(Store.logo_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : this.getAttribute(Store.domain_logo_gallery_attribute_name)) !== null && _ref !== void 0 ? _ref : this.getAttribute(Store.domain_logo_attribute_name);
  }
  getLogoUrl() {
    let logo = this.getLogo();
    return logo instanceof Image ? logo.getUrl() : null;
  }
  getFavicon() {
    var _this$getAttribute2;
    return (_this$getAttribute2 = this.getAttribute(Store.domain_favicon_attribute_name)) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : this.getAttribute(Store.domain_favicon_gallery_attribute_name);
  }
  getCustomData() {
    return this.getAttribute(Store.custom_data_attribute_name);
  }
  isPaymentWalletsEnabled() {
    let customData = this.getCustomData();
    return customData instanceof StoreCustomData ? customData.isPaymentWalletsEnabled() : null;
  }
  isDefault() {
    return this.getAttribute(Store.domain_is_default_attribute_name);
  }
  storeName() {
    return this.getAttribute(Store.title_attribute_name);
  }
  getPhoneNumber() {
    return this.getAttribute(Store.phone_number_attribute_name);
  }
  getCompanyLocation() {
    return this.getAttribute(Store.company_location_attribute_name);
  }
  getEmail() {
    return this.getAttribute(Store.domain_contact_email_attribute_name);
  }
  getDomainVerificationString() {
    return this.getAttribute(Store.domain_verification_string_attribute_name);
  }
  getDomainSelectObject(text = null, value = null, returnHoleObject = false) {
    let option = {
      [text !== null && text !== void 0 ? text : 'text']: this.getName(),
      [value !== null && value !== void 0 ? value : 'value']: this.getId()
    };
    if (returnHoleObject) option.domain = this;
    return option;
  }
  isSSL() {
    var _this$getAttribute3;
    return (_this$getAttribute3 = this.getAttribute(Store.domain_ssl_attribute_name)) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : false;
  }
  isDNS() {
    var _this$getAttribute4;
    return (_this$getAttribute4 = this.getAttribute(Store.domain_dns_attribute_name)) !== null && _this$getAttribute4 !== void 0 ? _this$getAttribute4 : false;
  }
  hasDnsActive() {
    var _this$isDNS;
    return (_this$isDNS = this.isDNS()) !== null && _this$isDNS !== void 0 ? _this$isDNS : false;
  }
  hasSslActive() {
    var _this$isSSL;
    return (_this$isSSL = this.isSSL()) !== null && _this$isSSL !== void 0 ? _this$isSSL : false;
  }
  getDomainName() {
    return this.getName();
  }
  getName() {
    const domain = this.getDomain();
    if (domain instanceof Domain) {
      return domain.getName();
    }
    const substitutionDomain = this.getSubstitutionDomain();
    if (substitutionDomain instanceof Domain) {
      return substitutionDomain.getName();
    }
  }
  getTitle() {
    return this.getAttribute(Store.title_attribute_name);
  }
  getPrimaryColor() {
    return this.getAttribute(Store.primary_color_attribute_name);
  }
  getSecondaryColor() {
    return this.getAttribute(Store.secondary_color_attribute_name);
  }
  getType() {
    return this.getAttribute(Store.domain_type_attribute_name);
  }
  isBrand() {
    return this.getType() === Store.BRAND_TYPE;
  }
  getDnsStatus() {
    return this.getAttribute(Store.domain_dns_attribute_name);
  }
  getSslStatus() {
    return this.getAttribute(Store.domain_ssl_attribute_name);
  }
  getTrackingData() {
    return this.getAttribute(Store.getTrackingDataAttributeName());
  }
  getCheckoutData() {
    return this.getAttribute(Store.getCheckoutDataAttributeName());
  }
  getStoreLayout() {
    return this.getAttribute(Store.getStoreLayoutAttributeName());
  }
  getLayout() {
    return this.getAttribute(Store.getStoreLayoutAttributeName());
  }
  getAddons() {
    return this.getAttribute(Store.getAddonsAttributeName());
  }
  getTheme() {
    const addons = this.getAddons();
    return addons instanceof Addons ? addons.getTheme() : null;
  }
  getLanguage() {
    return this.getAttribute(Store.getLanguageAttributeName());
  }
  getLanguageType() {
    return this.getAttribute(Store.getLanguageTypeAttributeName());
  }
  isMultipleLanguage() {
    return this.getLanguageType() === Store.MULTIPLE_LANGUAGE_TYPE;
  }
  isOneLanguage() {
    return this.getLanguageType() === Store.ONE_LANGUAGE_TYPE;
  }
  getLink() {
    const domain = this.getDomain();
    const substitutionDomain = this.getSubstitutionDomain();
    const domainName = domain instanceof Domain ? domain.getName() : substitutionDomain instanceof Domain ? substitutionDomain.getName() : null;
    if (!domainName) {
      return null;
    }
    return ['https://', domainName].join('');
  }
  getStorePages() {
    var _this$getAttribute5;
    return (_this$getAttribute5 = this.getAttribute(Store.getStorePagesAttributeName())) !== null && _this$getAttribute5 !== void 0 ? _this$getAttribute5 : [];
  }
  getHomePage() {
    return this.getStorePages().find(storePage => storePage instanceof StorePage && storePage.getType() === StorePage.HOME_PAGE);
  }
}
_defineProperty(Store, "GENERAL_TYPE", 'general');
_defineProperty(Store, "BRAND_TYPE", 'brand');
_defineProperty(Store, "COUNTRY_TYPE", 'country');
_defineProperty(Store, "DEFAULT_PRIMARY_COLOR", '#05254B');
_defineProperty(Store, "DEFAULT_SECONDARY_COLOR", '#70C5FF');
_defineProperty(Store, "ONE_LANGUAGE_TYPE", 'one-language');
_defineProperty(Store, "MULTIPLE_LANGUAGE_TYPE", 'multiple-language');
_defineProperty(Store, "AR_LANGUAGE", 'ar');
_defineProperty(Store, "EN_LANGUAGE", 'en');
_defineProperty(Store, "FR_LANGUAGE", 'fr');
_defineProperty(Store, "IT_LANGUAGE", 'it');
_defineProperty(Store, "ES_LANGUAGE", 'es');
_defineProperty(Store, "id_attribute_name", 'id');
_defineProperty(Store, "domain_id_attribute_name", 'domain_id');
_defineProperty(Store, "domain_type_attribute_name", 'domain_type');
_defineProperty(Store, "offer_id_attribute_name", 'offer_id');
_defineProperty(Store, "domain_offer_attribute_name", 'domain_offer');
_defineProperty(Store, "domain_type_country_id_attribute_name", 'domain_type_country_id');
_defineProperty(Store, "domain_type_country_attribute_name", 'domain_type_country');
_defineProperty(Store, "name_attribute_name", 'domain_name');
_defineProperty(Store, "domain_user_attribute_name", 'domain_user');
_defineProperty(Store, "domain_belong_type_attribute_name", 'domain_belong_type');
_defineProperty(Store, "domain_is_default_attribute_name", 'domain_is_default');
_defineProperty(Store, "title_attribute_name", 'domain_title');
_defineProperty(Store, "domain_contact_email_attribute_name", 'domain_contact_email');
_defineProperty(Store, "domain_logo_attribute_name", 'domain_logo');
_defineProperty(Store, "domain_favicon_attribute_name", 'domain_favicon');
_defineProperty(Store, "domain_dns_attribute_name", 'domain_dns');
_defineProperty(Store, "domain_ssl_attribute_name", 'domain_ssl');
_defineProperty(Store, "primary_color_attribute_name", 'domain_primary_color');
_defineProperty(Store, "secondary_color_attribute_name", 'domain_secondary_color');
_defineProperty(Store, "domain_logo_gallery_attribute_name", 'domain_logo_gallery');
_defineProperty(Store, "logo_attribute_name", 'logo');
_defineProperty(Store, "domain_favicon_gallery_attribute_name", 'domain_favicon_gallery');
_defineProperty(Store, "favicon_attribute_name", 'favicon');
_defineProperty(Store, "domain_verification_string_attribute_name", 'domain_verification_string');
_defineProperty(Store, "phone_number_attribute_name", 'phone_number');
_defineProperty(Store, "company_location_attribute_name", 'company_location');
_defineProperty(Store, "custom_data_attribute_name", 'custom_data');
_defineProperty(Store, "tracking_data_attribute_name", 'tracking_data');
_defineProperty(Store, "product_id_attribute_name", 'product_id');
_defineProperty(Store, "product_attribute_name", 'product');
_defineProperty(Store, "user_default_attribute_name", 'user_default');
_defineProperty(Store, "store_layout_attribute_name", 'store_layout');
_defineProperty(Store, "layout_id_attribute_name", 'layout_id');
_defineProperty(Store, "addons_attribute_name", 'addons');
_defineProperty(Store, "language_type_attribute_name", 'language_type');
_defineProperty(Store, "language_attribute_name", 'language');
_defineProperty(Store, "checkout_data_attribute_name", 'checkout_data');
_defineProperty(Store, "stripes_attribute_name", 'stripes');
_defineProperty(Store, "domain_attribute_name", 'domain');
_defineProperty(Store, "substitution_domain_attribute_name", 'substitution_domain');
_defineProperty(Store, "active_attribute_name", 'active');
_defineProperty(Store, "store_pages_attribute_name", 'store_pages');